module.exports = __webpack_public_path__ + "img/photo_250810863_1.1c45e136.jpg";